import { render, staticRenderFns } from "./DeleteConcentForm.vue?vue&type=template&id=d871a98c&"
import script from "./DeleteConcentForm.vue?vue&type=script&lang=js&"
export * from "./DeleteConcentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports